import React from 'react'

// 구축 예정 화면의 골격. 메뉴·권한을 먼저 잡아두고, 각 화면이 무엇을 받아 무엇을 내보내는지
// 설계를 화면에 적어둔다 (입력 → 하는 일 → 산출물). 실제 기능이 붙으면 이 파일에서 빠진다.

export const PLANNED = {
  sales: {
    title: '매출',
    lead: '채널별 주문을 한 곳에 모아 월 매출을 확정합니다. 초기 시안에 있던 화면인데 '
      + '원천(이카운트)이 아직 안 붙어 다시 세워 둡니다.',
    input: '이카운트 판매내역 · 채널별 주문 (자사몰 · 스마트스토어 · 쿠팡 · 온라인기타)',
    work: '주문 단위로 상품금액 · 쿠폰할인 · 배송비 · 부가세를 나눠 담고 월 합계를 확정',
    output: '월 매출 확정표 · 채널별/품목그룹별 매출 비중',
    need: '이카운트 연동 (또는 채널별 주문 내보내기 양식)',
  },
  closing_assets: {
    title: '자산대장',
    lead: '감가상각의 출발점. 자산 하나당 계정 세 쌍(자산·감가상각누계액·비용)을 등록해두면 이후 전표는 자동으로 만들어집니다.',
    input: '유형자산 목록 엑셀 (최초 1회) · 이후 신규 취득분만 추가',
    work: '취득일 · 취득가 · 내용연수 · 상각방법 · 잔존가 · 사용부서 · 자산계정 · 감가상각누계액 계정 · 비용계정 등록',
    output: '자산 목록 (감가상각 화면의 기준 데이터)',
    need: '유형자산 대장 엑셀',
  },
  closing_depreciation: {
    title: '감가상각',
    lead: '자산대장을 기준으로 월 상각비를 계산해 결산분개(결차/결대)를 만듭니다.',
    input: '자산대장',
    work: '월 상각비 자동계산(기중 취득·처분 반영) 확인 및 조정',
    output: '결산분개 → 전표승인 → 위하고 일반전표',
    need: '자산대장 등록 완료',
  },
  closing_prepaid: {
    title: '선급비용',
    lead: '보험료·수수료처럼 미리 낸 비용을 기간에 나눠 인식합니다.',
    input: '선급 계약 목록 (총액 · 기간 · 계정)',
    work: '계약 등록 → 월 배분표 확인',
    output: '결산분개 → 전표승인 → 위하고 일반전표',
    need: '선급비용 계약 목록',
  },
  closing_lease: {
    title: '리스',
    lead: '리스계약의 사용권자산·리스부채 상각 스케줄을 만들고 매월 전표를 냅니다.',
    input: '리스계약 (리스료 · 기간 · 할인율)',
    work: '계약 등록 → 사용권자산 상각 · 리스부채 이자 스케줄 확인',
    output: '결산분개 → 전표승인 → 위하고 일반전표',
    need: '리스 계약서 목록',
  },
  closing_close: {
    title: '결산 마감',
    lead: '해당 월의 결산분개를 모아 한 번에 승인 요청하고, 승인된 전표를 위하고 양식으로 내보냅니다.',
    input: '감가상각 · 선급비용 · 리스에서 만들어진 분개',
    work: '마감할 월 선택 → 생성될 전표 미리보기 → 일괄 승인요청',
    output: '위하고 [일반전표] 업로드 엑셀',
    need: '위하고 부서코드 (부서명만 쓰면 업로드가 거절됩니다)',
  },
  fund_plan: {
    title: '자금계획',
    lead: '월·주 단위 수입/지출 계획을 세웁니다. 결재가 끝난 미이체 건은 예정 지출로 자동으로 잡힙니다.',
    input: '수기 입력 + 전자결재 미이체 내역',
    work: '수입(매출대금·기타) / 지출(구매·인건비·세금·이자·투자) 항목별 계획 입력',
    output: '자금계획표 · 주간 자금수지 전망',
    need: '계획 항목 체계와 수립 단위(월/주) 확정',
  },
  fund_plan_actual: {
    title: '계획 대비 실적',
    lead: '계획과 실제 계좌 거래를 자동으로 맞춰보고 차이를 봅니다.',
    input: '자금계획 + 계좌 실거래 내역',
    work: '계획 항목별 실적 대사 · 차이 원인 확인',
    output: '계획 대비 실적표',
    need: '자금계획 화면 완료',
  },
}


// 화면 시안. 글로만 설명하면 "그래서 어떻게 생겼는데"에 답이 안 된다. 실제 배치를 그려
// 두되, 숫자는 예시라는 것을 못 알아볼 수 없게 띠를 두른다 - 실제 데이터가 들어간
// 화면으로 오해되면 안 된다.
export const MOCKS = {
  closing_assets: {
    metrics: [['등록 자산', '128건'], ['취득가액 계', '1,842백만'], ['당월 상각비', '23.4백만'], ['미상각잔액', '971백만']],
    columns: ['자산코드', '자산명', '취득일', '취득가액', '내용연수', '상각방법', '당월상각비', '미상각잔액', '사용부서'],
    rows: [
      ['FA-0031', '물류창고 지게차', '2024-03-11', '38,000,000', '5년', '정액법', '633,333', '19,633,334', '매장영업팀'],
      ['FA-0058', '사무실 인테리어', '2025-01-20', '96,400,000', '5년', '정액법', '1,606,667', '65,873,333', '전체공통'],
      ['FA-0072', '서버·네트워크 장비', '2025-08-02', '14,200,000', '4년', '정액법', '295,833', '10,654,167', '전략기획실'],
    ],
  },
  closing_depreciation: {
    metrics: [['당월 상각비', '23.4백만'], ['감가상각누계액', '871백만'], ['대상 자산', '128건'], ['미확정', '0건']],
    columns: ['자산명', '자산계정', '취득가액', '기초누계', '당월상각', '기말누계', '비용계정'],
    rows: [
      ['물류창고 지게차', '차량운반구', '38,000,000', '17,733,333', '633,333', '18,366,666', '감가상각비'],
      ['사무실 인테리어', '시설장치', '96,400,000', '28,920,000', '1,606,667', '30,526,667', '감가상각비'],
      ['서버·네트워크 장비', '비품', '14,200,000', '3,250,000', '295,833', '3,545,833', '감가상각비'],
    ],
  },
  closing_prepaid: {
    metrics: [['진행 계약', '17건'], ['계약 총액', '284백만'], ['당월 인식액', '11.8백만'], ['잔여 선급액', '96백만']],
    columns: ['계약명', '거래처', '계약총액', '기간', '월 배분액', '당월 인식', '잔여'],
    rows: [
      ['화재보험료 (물류창고)', '삼성화재', '18,000,000', '2026-01 ~ 2026-12', '1,500,000', '1,500,000', '6,000,000'],
      ['ERP 유지보수료', '신세계아이앤씨', '27,060,000', '2026-03 ~ 2027-02', '2,255,000', '2,255,000', '15,785,000'],
      ['임차 중개수수료', '한국자산관리', '4,800,000', '2026-05 ~ 2027-04', '400,000', '400,000', '3,200,000'],
    ],
  },
  closing_lease: {
    metrics: [['리스 계약', '6건'], ['사용권자산', '412백만'], ['리스부채', '388백만'], ['당월 이자비용', '1.4백만']],
    columns: ['계약명', '월 리스료', '기간', '할인율', '사용권자산 상각', '리스부채 이자', '잔여부채'],
    rows: [
      ['본사 사무실', '12,400,000', '2025-07 ~ 2028-06', '4.8%', '10,830,000', '1,046,000', '261,400,000'],
      ['물류창고 A동', '5,900,000', '2026-01 ~ 2028-12', '4.8%', '5,120,000', '318,000', '96,700,000'],
      ['업무용 차량 3대', '1,850,000', '2025-10 ~ 2028-09', '4.8%', '1,610,000', '84,000', '29,900,000'],
    ],
  },
  closing_close: {
    metrics: [['마감 대상월', '2026-06'], ['미결 전표', '3건'], ['검증 항목', '9개 중 7개 통과'], ['상태', '진행중']],
    columns: ['확인 항목', '상태', '값', '담당', '확인일'],
    rows: [
      ['전표 승인 완료', '통과', '전건 승인', '재무경영팀', '2026-07-03'],
      ['감가상각 반영', '통과', '23,400,000', '재무경영팀', '2026-07-03'],
      ['선급비용 배분', '통과', '11,800,000', '재무경영팀', '2026-07-03'],
      ['재고 실사 반영', '확인 필요', '차이 2품목', '매장영업팀', '—'],
      ['위하고 전송', '대기', '—', '재무경영팀', '—'],
    ],
  },
  sales: {
    metrics: [['월 매출', '418백만'], ['순매출 (할인·환불 반영)', '390백만'], ['활성 채널', '4개'], ['미반영 건', '0건']],
    columns: ['일자', '채널', '품목', '수량', '상품금액', '쿠폰할인', '배송비', '부가세', '합계'],
    rows: [
      ['07-15', '자사몰', 'ECLL 스포츠 비치가운_AB', '1', '10,818', '0', '0', '1,082', '11,900'],
      ['07-16', '스마트스토어', 'ECLL 오버핏 라운드넥 티셔츠', '1', '27,270', '-2,000', '0', '2,527', '27,800'],
      ['07-16', '쿠팡', 'ECLL 스포츠타월 4개1세트', '2', '21,636', '0', '3,000', '2,464', '27,100'],
    ],
    bars: [['자사몰', 44], ['스마트스토어', 29], ['쿠팡', 21], ['온라인기타', 6]],
  },
}

export default function Planned({ spec }) {
  const s = PLANNED[spec]
  if (!s) return null
  return (
    <>
      <h2>{s.title} <span className="badge-planned">구축 예정</span></h2>
      <div className="panel">
        <div className="hint" style={{ marginTop: 0, fontSize: 13 }}>{s.lead}</div>
        <table style={{ maxWidth: 900, marginTop: 12 }}>
          <tbody>
            <tr><td className="l" style={{ width: 110, background: '#F8FAFC' }}>입력</td><td className="l">{s.input}</td></tr>
            <tr><td className="l" style={{ background: '#F8FAFC' }}>하는 일</td><td className="l">{s.work}</td></tr>
            <tr><td className="l" style={{ background: '#F8FAFC' }}>산출물</td><td className="l">{s.output}</td></tr>
            <tr><td className="l" style={{ background: '#F8FAFC' }}>필요한 것</td><td className="l warn">{s.need}</td></tr>
          </tbody>
        </table>
        <div className="hint">
          메뉴와 권한만 먼저 잡아둔 화면입니다. 위 &lsquo;필요한 것&rsquo;이 확보되는 순서대로 기능을 붙입니다.
        </div>
      </div>
      {MOCKS[spec] && <Mock m={MOCKS[spec]} />}
    </>
  )
}

function Mock({ m }) {
  return (
    <div className="panel mock" style={{ marginTop: 14 }}>
      <div className="mock-band">
        화면 시안 &mdash; <b>아래 숫자는 화면 모양을 보이기 위한 예시</b>이며 실제 데이터가 아닙니다.
      </div>
      <div className="mock-body">
        <div className="mock-metrics">
          {m.metrics.map(([k, v]) => (
            <div key={k} className="mock-metric">
              <div className="mock-mk">{k}</div>
              <div className="mock-mv">{v}</div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 520px', overflowX: 'auto' }}>
            <table className="mock-table">
              <thead><tr>{m.columns.map((c) => <th key={c}>{c}</th>)}</tr></thead>
              <tbody>
                {m.rows.map((r, i) => (
                  <tr key={i}>{r.map((v, j) => (
                    <td key={j} className={j === 0 || /[가-힣]/.test(String(v)) ? 'l' : ''}>{v}</td>
                  ))}</tr>
                ))}
              </tbody>
            </table>
          </div>
          {m.bars && (
            <div className="mock-bars">
              <div className="mock-mk" style={{ marginBottom: 8 }}>채널별 매출 비중</div>
              {m.bars.map(([k, v]) => (
                <div key={k} className="mock-bar">
                  <span>{k}</span>
                  <span className="mock-track"><span className="mock-fill" style={{ width: v + '%' }} /></span>
                  <span className="mock-pct">{v}%</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
